import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PanelPatientDataDisplay } from '../sharedPanelComponents/PanelPatientDataDisplay'
import { getPCCCoverages, getPCCData } from '../../../../../helper/pccApiHelper'
import { PatientInsuranceDisplay } from '../../../../../components/common/shared/sharedPatientCode'
import { CSpinner } from '@coreui/react-pro'
import { setPanelPCCHelper } from '../../../../../redux/sidePanel/sidePanelSlice'

const getPccInsuranceInformation = async (patientId, dispatch) => {
  const pccData = await getPCCData(patientId)
  const pccCoverages = await getPCCCoverages(patientId)
  if (pccData) {
    dispatch(
      setPanelPCCHelper({
        field: 'insuranceInfoData',
        value: { ...pccData, coverages: pccCoverages },
      }),
    )
  }
}

export default function PanelPatientInsurance() {
  const dispatch = useDispatch()
  const patientId = useSelector((state) => state.sidePanel.panelEncounter?.patient_id)
  const insuranceInfoData = useSelector(
    (state) => state.sidePanel.panelPatientPCCData?.insuranceInfoData,
  )

  const dataMissing = Object.keys(insuranceInfoData || {}).length === 0

  const [isLoading, setIsLoading] = useState(dataMissing)

  useEffect(() => {
    if (patientId && dataMissing) {
      getPccInsuranceInformation(patientId, dispatch).then(() => setIsLoading(false))
    }
  }, [dispatch, patientId, dataMissing])

  return (
    <div id={'PanelPatientInsurance'} className={`display-box `}>
      {isLoading ? (
        <div className={'d-flex justify-content-center'}>
          <CSpinner />
        </div>
      ) : Object.keys(insuranceInfoData).length === 0 ? (
        'No Data Found'
      ) : (
        <PatientInsuranceDisplay
          insuranceInfoData={insuranceInfoData}
          DisplayFunction={PanelPatientDataDisplay}
        />
      )}
    </div>
  )
}
